(function () {
  var currentUrl = window.location.href;
  var shopUrl = window.location.origin; // Automatically retrieves the shop URL
  var destinationPage = shopUrl + "/pages/organizations-page"; // Replace with your destination page URL

  // Regular expressions for the URLs to exclude
  var excludePatterns = [
    new RegExp(shopUrl + "/pages/organizations-page"),
    new RegExp(shopUrl + "/checkouts/.*"),
    new RegExp(shopUrl + "/.+?/orders/.*"),
    new RegExp(shopUrl + "/account/reset/.*"),
    new RegExp(shopUrl + "/_t/c/.*"),
  ];

  // Check if the current URL matches any of the exclude patterns
  var shouldExclude = excludePatterns.some(function (pattern) {
    return pattern.test(currentUrl);
  });

  // Redirect if the current URL doesn't match any exclude patterns
  if (!shouldExclude) {
    window.location.href = destinationPage;
  }
})();
